import { render, staticRenderFns } from "./SubAreaContainer.vue?vue&type=template&id=35f652b2&scoped=true"
import script from "./SubAreaContainer.vue?vue&type=script&lang=js"
export * from "./SubAreaContainer.vue?vue&type=script&lang=js"
import style0 from "./SubAreaContainer.vue?vue&type=style&index=0&id=35f652b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f652b2",
  null
  
)

export default component.exports